
import { FSXABaseSection } from 'fsxa-pattern-library'
import { Component } from 'nuxt-property-decorator'
import BaseGridLayout from '../../layouts/BaseGridLayout.vue'

interface IFormData {
  uid : string
  fd : string
  lang : string
}

interface IFormPayload {
  form ?: {
    fsType : string
    name : string
    value ?: IFormData
  }
}

@Component({
  name: 'StHeadlessForm',
  components: { BaseGridLayout },
})
export default class StHeadlessForm extends FSXABaseSection<IFormPayload> {
  /**
   * Because of async component imports this flag prevents the following error in conjunction with the Formcentric client:
   * - warning No Formcentric-FormDiv was found. You either forgot the "defer"-Attribute on the Script-Tag or are missing a form div
   */
  private mountedDone : boolean = false

  async mounted () {
    // eslint-disable-next-line import/no-extraneous-dependencies
    await import('@formcentric/client/dist/formapp.js')
    // eslint-disable-next-line import/no-extraneous-dependencies
    await import('@formcentric/client/dist/formcentric.js')

    this.mountedDone = true
    this.$nextTick(() => {
      window.formcentric.initFormcentric()
    })
  }

  private get host () : string {
    return process.client ? window.location.origin : 'http://localhost:3000'
  }

  private get form () : IFormData {
    return this.payload.form?.value || { uid: '', fd: '', lang: '' }
  }
}
